import { Flex, Heading, Stack, Text } from '@chakra-ui/react';

import { colors, spacing } from '@/styles/ui.theme';

import { nodeHeight, nodeWidth } from './course-structure';

type Props = {
  data: {
    superHeading: string;
    title: string;
    childrenCount?: number;
  } & any;
};

const BaseNode = ({ data }: Props): React.ReactElement => {
  return (
    <Flex
      w='100%'
      h='auto'
      maxW={nodeWidth}
      maxH={nodeHeight}
      direction='column'
      alignSelf='flex-start'
      p={spacing.gutter}
      border='1px'
      borderColor='gray.200'
      background={colors.descomplica.gray['background-white']}
    >
      <Stack>
        <Text
          color={colors.descomplica.green.primary}
          textTransform={'uppercase'}
          fontWeight={800}
          fontSize={{ base: 'sm', sm: 'xs', md: 'sm' }}
          letterSpacing={1.1}
        >
          {data.superHeading}
        </Text>
        <Heading
          color='gray.700'
          fontSize={{ base: '2xl', sm: 'xl', md: '2xl' }}
          fontFamily={'body'}
        >
          {data.title}
        </Heading>
        <Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'xs', md: 'sm' }}>
          {data.childrenCount ? `${data.childrenCount} itens` : 'Eita, não contamos'}
        </Text>
      </Stack>
    </Flex>
  );
};

export default BaseNode;
